import React, { useState } from 'react';
import {
  type CategoriaTorneio,
  type InscricoesPorTorneioData,
} from '../../../services/torneioService';
import TournamentFinanceiroResumoTab from './TournamentFinanceiroResumoTab';
import TournamentChargesTab from './TournamentChargesTab';
import TournamentFinanceiroInscricoesTab from './TournamentFinanceiroInscricoesTab';
import TournamentFinanceiroRecebimentosTab from './TournamentFinanceiroRecebimentosTab';
import TournamentFinanceiroPagamentosTab from './TournamentFinanceiroPagamentosTab';

type SubTabId = 'resumo' | 'categorias' | 'inscricoes' | 'recebimentos' | 'pagamentos';

const SUB_TABS: { id: SubTabId; label: string }[] = [
  { id: 'resumo', label: 'Resumo' },
  { id: 'categorias', label: 'Categorias' },
  { id: 'inscricoes', label: 'Inscrições' },
  { id: 'recebimentos', label: 'Recebimentos' },
  { id: 'pagamentos', label: 'Pagamentos' },
];

interface TournamentFinanceiroTabProps {
  torneioId: string;
  categorias: CategoriaTorneio[];
  inscricoes: InscricoesPorTorneioData['inscricoesTorneioPorAtletaIdTorneioId'];
  ligaId: string;
  canManagePayments: boolean;
}

const TournamentFinanceiroTab: React.FC<TournamentFinanceiroTabProps> = ({
  torneioId,
  categorias,
  inscricoes,
  ligaId,
  canManagePayments,
}) => {
  const [activeSubTab, setActiveSubTab] = useState<SubTabId>('resumo');

  return (
    <div className="mt-3">
      {/* Sub-tab navigation */}
      <ul className="nav nav-tabs mb-3" role="tablist">
        {SUB_TABS.map((tab) => (
          <li key={tab.id} className="nav-item" role="presentation">
            <button
              type="button"
              className={`nav-link ${activeSubTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveSubTab(tab.id)}
              role="tab"
              aria-selected={activeSubTab === tab.id}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {/* Sub-tab content */}
      {activeSubTab === 'resumo' ? (
        <TournamentFinanceiroResumoTab torneioId={torneioId} />
      ) : activeSubTab === 'categorias' ? (
        <TournamentChargesTab
          torneioId={torneioId}
          categorias={categorias}
          inscricoes={inscricoes}
          ligaId={ligaId}
          canManagePayments={canManagePayments}
        />
      ) : activeSubTab === 'inscricoes' ? (
        <TournamentFinanceiroInscricoesTab
          torneioId={torneioId}
          categorias={categorias}
          inscricoes={inscricoes}
        />
      ) : activeSubTab === 'recebimentos' ? (
        <TournamentFinanceiroRecebimentosTab
          torneioId={torneioId}
          categorias={categorias}
        />
      ) : (
        <TournamentFinanceiroPagamentosTab
          torneioId={torneioId}
          ligaId={ligaId}
          categorias={categorias}
        />
      )}
    </div>
  );
};

export default TournamentFinanceiroTab;
